import { Check, Minus } from '@phosphor-icons/react';
import { Checkbox as C } from 'radix-ui';
import type { ComponentProps } from 'react';
import { cn } from '@/lib/cn';

export function Checkbox({ className, ...props }: ComponentProps<typeof C.Root>) {
  return (
    <C.Root
      className={cn(
        'flex size-5 shrink-0 items-center justify-center rounded-[5px] border border-input bg-card transition-colors hover:border-foreground/60 data-[state=checked]:border-primary data-[state=checked]:bg-primary data-[state=indeterminate]:border-primary data-[state=indeterminate]:bg-primary disabled:cursor-not-allowed disabled:opacity-50',
        className,
      )}
      {...props}
    >
      <C.Indicator className="text-primary-foreground">
        {props.checked === 'indeterminate' ? <Minus className="size-3.5" weight="bold" aria-hidden /> : <Check className="size-3.5" weight="bold" aria-hidden />}
      </C.Indicator>
    </C.Root>
  );
}
